// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"aff7e410","453":"970b3650","667":"ba6225be"}[chunkId] + ".chunk.js";
};